import { render, staticRenderFns } from "./RequestActualizationConfirm.vue?vue&type=template&id=540bae2a&"
import script from "./RequestActualizationConfirm.vue?vue&type=script&lang=js&"
export * from "./RequestActualizationConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QSeparator,QCardActions,QBtn} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QSeparator,QCardActions,QBtn}, component.options.components || {})
